<template>
  <div class="card__wrapper">
    <div class="card">
      <h1 class="card__title">{{ $t('messages.privacy_statement') }}</h1>
      <div class="card__description card__margin">
        <p v-html="getData()"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.privacy_statement') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.privacy_statement'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  methods: {
    getData: function () {
      let dataUrl = 'i18n/privacy/' + this.$i18n.locale + '.html'
      return require('@/' + dataUrl)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Privacy.vue